import { JobPostingData } from "@/storyblok/schemas";
import { JsonLd } from "react-schemaorg";
import { JobPosting, WithContext } from "schema-dts";

export default function JobPostingLD({ data }: { data: JobPostingData }) {
  const jobPosting: WithContext<JobPosting> = {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    datePosted: data.date_posted?.toString(),
    directApply: true,
    employerOverview: data.employer_overview,
    employmentType: data.employment_type,
    estimatedSalary: data.estimated_salary,
    industry: data.industry,
    jobBenefits: data.job_benefits,
    jobImmediateStart: data.job_immediate_start,
    jobLocation: {
      "@type": "Place",
      address: data.job_location,
    },
    jobLocationType: data.job_location_type,
    jobStartDate: data.job_start_date?.toString(),
    physicalRequirement: data.physical_requirements,
    qualifications: data.qualifications,
    responsibilities: data.responsibilities,
    salaryCurrency: "EUR",
    skills: data.skills,
    title: data.title,
    description: data.description,
    totalJobOpenings: data.total_job_openings,
    validThrough: data.valid_through?.toString(),
    workHours: data.work_hours,
    hiringOrganization: {
      "@type": "Organization",
      name: data.hiring_organization,
      logo: data.hiring_organization_logo?.filename,
    },
  };

  return <JsonLd<JobPosting> item={jobPosting} />;
}
